import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import '@/assets/Global.css'
import store from './store'
import zhCn from 'element-plus/es/locale/lang/zh-cn';

const app = createApp(App) 
// 将所有图标组件逐一全局注册
for (const [key, component] of Object.entries(ElementPlusIconsVue)) { 
	app.component(key, component) 
} 

app.use(store).use(router).use(ElementPlus,{locale:zhCn}).mount('#app')

// createApp(App).use(router).use(ElementPlus).mount('#app')
